import styled from "styled-components";
import { ButtonStyle } from "../../../globalStyles";

export const Container = styled.div`
  display: flex;
  background: ${({ background }) => background};
  min-height: calc(250px - 32px);
  padding: 18px 32px;
  padding-bottom: 32px;
  border-radius: 10px;

  &.mobile-container {
    flex-direction: column;
    margin: 32px;

    .header {
      margin-bottom: 0px;
      margin-left: 16px;
    }

    .license-button, .subscribe-button {
      max-width: fit-content;
    }
  }

  .mobile-card-header {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
  }

  .number {
    width: 46.73px;
    height: 44.74px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.white};
    /* padding: 11px 16px 9px 16px; */
    border-radius: 8px;

    p {
      color: ${({ background }) => background};
      font-family: ${({ theme }) => theme.p1b.ff};
      font-size: 24px;
      margin-top: 4px;
    }
  }

  .content {
    flex: 2;
    padding-right: 120px;
    margin-left: 32px;
    margin-top: 8px;
  }

  .title {
    color: white;
    font-size: ${({ theme }) => theme.h2.fs};
    font-family: ${({ theme }) => theme.h2.ff};
    letter-spacing: ${({ theme }) => theme.h2.letterSpacing};
  }
  
  .button-container {
    display: flex;
    flex-flow: row wrap;
  }

  .license-button, .subscribe-button {
    ${ButtonStyle}
    background: ${({ background }) => background};
    border: 2px solid ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.white};
  }
  
  .subscribe-button {
    background: ${({ theme }) => theme.white};
    color: ${({ background }) => background};
    margin-right: 20px;
  }
`;

export const ArrowIcon = styled.img`
  margin-right: 10px;
  transform: ${({ isCollapsed }) => (isCollapsed ? "rotate(180deg)" : "unset")};
  transition: transform 0.18s ease;
`;
